module.exports = __webpack_public_path__ + "img/pantalla-4-1-mobile.60eacd9d.png";